// src/App.js
import "./i18n";
import { BrowserRouter, Routes, Route } from "react-router-dom";

// Auth
import { AuthProvider } from "./auth/useAuth";
import RequireAuth from "./auth/RequireAuth";
import RequireAdmin from "./auth/RequireAdmin";

// UI / Layout
import NavBar from "./components/NavBar";
import FeedbackButton from "./components/FeedbackButton";

// Pages publiques
import Home from "./pages/Home";
import Register from "./pages/Register";
import Login from "./pages/Login";

// Pages protégées (utilisateur connecté)
import Dashboard from "./pages/Dashboard";
import Reservations from "./pages/Reservations";
import Labs from "./pages/Labs";
import UserStatsDashboard from "./pages/UserStatsDashboard";
import MyEligibleLabsPage from "./pages/MyEligibleLabsPage";
import LabNodesPage from "./pages/LabNodesPage";
import LabWorkspacePage from "./pages/LabWorkspacePage";
import LabConsolePage from "./pages/LabConsolePage";
//#endregion



// Pages Admin
import AdminStatsDashboard from "./pages/admin/AdminStatsDashboard";
import AdminLabRulesPage from "./pages/admin/AdminLabRulesPage";
import AdminLabsPage from "./pages/admin/AdminLabsPage";
import AdminCreditsQuotasPage  from "./pages/admin/AdminCreditsQuotasPage";
import UserCreditsPage  from "./pages/UserCreditsPage";
import Profile          from "./pages/Profile";
import AdminUserManagementPage  from "./pages/admin/AdminUserManagementPage";
import AdminMonitoringPage from "./pages/admin/AdminMonitoringPage"
import SsoCallback from "./pages/SsoCallback";
import GradingHistoryPage from "./pages/GradingHistoryPage";
//import AdminUserCreditsPage from "./pages/admin/AdminUserCreditsPage";
//import AdminCreditsSettingsPage from "./pages/admin/AdminCreditsSettingsPage";
import AdminLabTagsPage from "./pages/admin/AdminLabTagsPage";
import AdminPackagesPage from "./pages/admin/AdminPackagesPage";
import AdminUserCreditsPage from "./pages/admin/AdminUserCreditsPage";
import AdminCreditsSettingsPage from "./pages/admin/AdminCreditsSettingsPage";
import AdminTagsPage from "./pages/admin/AdminTagsPage";
import AdminAuditLogPage from "./pages/admin/AdminAuditLogPage";
import AdminCreditTransactionsPage from "./pages/admin/AdminCreditTransactionsPage";
import AdminActivatePackPage from "./pages/admin/AdminActivatePackPage";
import AdminSettingsPage from "./pages/admin/AdminSettingsPage";
import AdminIncidentsPage    from "./pages/admin/AdminIncidentsPage";
import AdminGradingPage      from "./pages/admin/AdminGradingPage";
import RequireTeacher         from "./auth/RequireTeacher";
import TeacherDashboard       from "./pages/teacher/TeacherDashboard";
import TeacherLivePage        from "./pages/teacher/TeacherLivePage";
import TeacherGradingPage     from "./pages/teacher/TeacherGradingPage";
import TeacherStudentsPage    from "./pages/teacher/TeacherStudentsPage";
import AdminRecordingsPage   from "./pages/admin/AdminRecordingsPage";
import AdminLabBundlePage    from "./pages/admin/AdminLabBundlePage";
//import { adminRoutes } from "./routes/adminRoutes";
import Gns3NodesAdmin from "./pages/Gns3NodesAdmin";
import { OrgProvider }  from "./context/OrgContext";
import OrgDashboard     from "./pages/OrgDashboard";

// MUI Date Pickers
import { LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";

export default function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <OrgProvider>
        <LocalizationProvider dateAdapter={AdapterDayjs}>
          <NavBar />
          <FeedbackButton />
          <Routes>
            {/* Public */}
            <Route path="/" element={<Home />} />
            <Route path="/login" element={<Login />} />
            <Route path="/register" element={<Register />} />
            <Route path="/sso/callback" element={<SsoCallback />} />

            {/* Protégées (auth requise) */}
            <Route element={<RequireAuth />}>
              <Route path="/dashboard" element={<Dashboard />} />
              <Route path="/reservations" element={<Reservations />} />
              <Route path="/labs" element={<MyEligibleLabsPage />} />
              <Route path="/me/stats" element={<UserStatsDashboard />} />
              <Route path="/user/credits" element={<UserCreditsPage />} />
              <Route path="/me/credits" element={<UserCreditsPage />} />
              <Route path="/profile" element={<Profile />} />
              <Route path="/me/grading" element={<GradingHistoryPage />} />
              <Route path="/org/dashboard" element={<OrgDashboard />} />

              {/* Teacher */}
              <Route element={<RequireTeacher />}>
                <Route path="/teacher/dashboard" element={<TeacherDashboard />} />
                <Route path="/teacher/live"      element={<TeacherLivePage />} />
                <Route path="/teacher/grading"   element={<TeacherGradingPage />} />
                <Route path="/teacher/students"  element={<TeacherStudentsPage />} />
              </Route>
              <Route path="/lab/:reservationId" element={<LabWorkspacePage />} />
              <Route path="/lab/:reservationId/nodes" element={<LabNodesPage />} />
              <Route path="/lab/:reservationId/console/:nodeId" element={<LabConsolePage />} />




              


              {/* Admin-only */}
              <Route element={<RequireAdmin />}>
                <Route path="/admin/stats" element={<AdminStatsDashboard />} />
                <Route path="/admin/lab-rules" element={<AdminLabRulesPage />} />
                <Route path="/admin/labs" element={<AdminLabsPage />} />
                <Route path="/admin/credits" element={<AdminCreditsQuotasPage />} />
                <Route path="/admin/users" element={<AdminUserManagementPage />} />  
                <Route path="/admin/monitoring" element={<AdminMonitoringPage />} />
                <Route path="/admin/tags" element={<AdminTagsPage />} />
                <Route path="/admin/labs-tags" element={<AdminLabTagsPage  />} />
                <Route path="/admin/usercredits" element={<AdminUserCreditsPage   />} />
                <Route path="/admin/packages" element={<AdminPackagesPage  />} />
                <Route path="/admin/credits-settings" element={<AdminCreditsSettingsPage  />} />
                <Route path="/admin/audit-logs" element={<AdminAuditLogPage />} />
                <Route path="/admin/credit-transactions" element={<AdminCreditTransactionsPage />} />
                <Route path="/admin/activate-pack" element={<AdminActivatePackPage />} />
                <Route path="/admin/settings" element={<AdminSettingsPage />} />
                <Route path="/admin/incidents"   element={<AdminIncidentsPage />} />
                <Route path="/admin/grading"     element={<AdminGradingPage />} />
                <Route path="/admin/recordings"  element={<AdminRecordingsPage />} />
                <Route path="/admin/lab-bundles" element={<AdminLabBundlePage />} />
                <Route path="/admin/gns3-nodes" element={<Gns3NodesAdmin />} />
              </Route>
            </Route>
          </Routes>
        </LocalizationProvider>
        </OrgProvider>
      </AuthProvider>
    </BrowserRouter>
  );
}
